// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { MainPanel } from "types";
import { IState } from "states/states";
import { IAction } from "actions";
import { ICondition } from "shared/types/parameter";
import { isSet, round } from "shared/utils/utils";

interface IConditionExtProps {
  index: number;
  showDetail: boolean;
}

interface IConditionProps {
  parameter: ICondition;
  value: number | undefined;
  showId: boolean;
}

const mapStateToProps = (state: IState, ownProps: IConditionExtProps) => {
  const curUser = state.site.userList?.find((curItem) => curItem.secId === state.site.user?.secId);
  const parameter = state.para.parameter!.condition[ownProps.index];
  const props: IConditionProps = {
    parameter,
    value: state.data.condition[ownProps.index],
    showId: Boolean(curUser?.accessRights.setVirtualParameters),
  };
  return props;
};

interface IConditionDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IConditionDispatch = {};
  return dispatchProps;
};

class ConditionComponent extends React.Component<
  IConditionExtProps & IConditionProps & IConditionDispatch
> {
  public render() {
    return (
      <tr className="conditionitem">
        {this.props.showId && <td className="optional-md">{this.props.parameter.id}</td>}
        <td>
          {this.props.showDetail ?
            <Link to={`../${MainPanel.CONDITIONDETAIL}?condition=${this.props.index}`}>
              {this.props.parameter.name}
            </Link>
          : this.props.parameter.name}
        </td>
        <td className="value-col right">{round(this.props.value, 6)}</td>
      </tr>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConditionComponent);
